<template>
  <div class="text-center">
    <h1>
      Favorecido:
      <strong>{{ favored.company }}</strong>
    </h1>
    <div class="favored-mob">
      <b>{{ favored.cnpj | cpfCnpj }}</b>
      <p>{{ favored.company }}</p>
      <p>
        Plano:
        <strong>{{ favored.plan }}</strong>
      </p>
    </div>
    <div class="ico-box">
      <img src="static/CarteiraEnvia.svg" alt="" width="90">
      <img src="static/Transferencia_verde.png" alt="" width="90">
      <img src="static/CarteiraEnvia.svg" alt="" width="90">
    </div>
    <h1 class="bold">Qual o valor da transferência?</h1>
    <p class="balance-mob" v-if="balance">
      Saldo disponível para transferência
      <strong>{{ balance | cents}}</strong>
    </p>
    <div class="value-box">
      <input type="text" v-bind:value="getValue" v-on:input="setValue($event.target.value)"  name="input-transfer-value" class="form-control input-transfer-value" placeholder="0,00"  autofocus="autofocus">
      <div class="values" v-if="currentValue && !checkTransferValue">
        <div>
          <p>Taxa (2%)</p>
          <b>{{ currentValue * 0.02 | cents }}</b>
        </div>
        <div>
          <p class="bold-600">Total</p>
          <b>{{ currentValue * 1.02 | cents }}</b>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
div.text-center {
  h1 {
    font-size: 28px;
    &.bold {
      font-size: 35px;
    }
  }
  h1, b {
    color: #444;
  }
}
.ico-box {
  margin: 46px 0 30px;
  img {
    &:nth-child(2) {
      margin: 0 10px;
    }
  }
}
.value-box {
  width:                                525px;
  margin:                               0 auto;
  .values {
    > div {
      width: 150px;
      float: left;
      text-align: center;
      margin-top: 10px;
      p {
        color: #252525;
        margin-bottom: 5px;
        font-size: 16px;
      }
      b {
        font-size: 18px;
      }
      &:last-child {
        float: right;
        p {
          font-size: 25px;
        }
      }
    }
  }
}
.input-transfer-value {
  -webkit-border-radius:                0;
  border-radius:                        0;
  background:                           transparent;
  border:                               0;
  border-bottom:                        1px solid #b5b5b5;
  display:                              inline;
  font-weight:                          bold;
  font-size:                            35px;
  height:                               65px;
  // margin:                               0 -5px 0 -1px;
  text-align:                           center;
  width:                                100%;
  box-shadow:                           unset;
}

.balance-mob,
.favored-mob {
  display: none;
}

.balance-mob {
  font-size: 12px;
  line-height: 1;
  strong {
    color: #2C865A;
  }
}

.favored-mob {
  text-align: left;
  b {
    color: #613A7D !important;
  }
  p {
    font-size: 14px;
    color: #848484;
    display: block;
    width: 100%;
    text-align: unset;
    margin: 0;
    line-height: 1.2;
    &:last-child {
      font-size: 10px;
      strong {
        font-size: 13px;
        color: #63A70A;
      }
    }
  }
}

@media (max-width: 991px) {
  div.text-center {
    h1 {
      display: none;
      &.bold {
        font-size: 17px;
        display: block;
      }
    }
  }
  .favored-mob, .balance-mob {
    display: block;
  }
  .ico-box {
    img {
      width: 65px;
      &:nth-child(2) {
        margin: 0 10px;
      }
    }
  }
  .value-box {
    width:                                270px;
    .values {
      > div {
        width: 130px;
        p {
          font-size: 14px;
        }
        b {
          font-size: 15px;
        }
        &:last-child {
          p {
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>
<script>
import { centss } from "../../../filters/number";

export default {
  props: ["value",'hideIncrement', 'favored', 'balance'],
  data() {
    return {
      currentValue: this.value,
    };
  },
  mounted() {
  },
  computed: {
    getValue() {

      if (this.currentValue || this.currentValue == 0)
        return centss(this.currentValue);

      return "";
    },
    checkTransferValue(){
      return this.currentValue * 1.02 > this.balance;
    },
  },
  watch:{
      value(newValue){
        this.currentValue = newValue;
      }
  },
  methods: {
    alterValue(value){
      let newValue = this.currentValue + value;

      if(newValue < 0)return false;

      this.setValue('' + newValue);
    },
    setValue(newValue) {
      if (!Number.isNaN(newValue) && newValue != "") {
        this.currentValue = parseInt(newValue.replace(/[^0-9]/g, ""));
        this.$emit("input", this.currentValue);
      } else {
        this.currentValue = newValue;
        this.$emit("input", undefined);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// transfer-shipper-value.vue?39fc54be